/**
 *
 */

// 所有可以的验证规则处理类存放的地方, 自定义的检验类型
var types = {}
var typesMsg = {}
// 验证类型所对应的错误消息
var messages = []
// 传入需要检验的类型
var config = {}
var _name_ = {}

// 最小位数
extend('min', (val, min) => {
  return val + '不能小于' + min + '位'
}, (val, min) => {
  if (val) {
    return val.length > (min - 1)
  } else {
    return true
  }
})
// 最大位数
extend('max', (val, max) => {
  return val + '不能大于' + max + '位'
}, (val, max) => {
  if (val) {
    return val.length < (max + 1)
  } else {
    return true
  }
})
// 金额 小数点后两位
extend('gold', (val) => {
  return val + '只能数字且保留两位小数'
}, (val) => {
  return /^\d{1,9}(\.{0}|\.{1}\d{1,2})?$/.test(val)
})
// 最小中文数
extend('minInZh_CN', (val, min) => {
  return val + ' 长度不能小于' + min + '位(包含中文)'
}, (val, min) => {
  if (val) {
    let leng = zh_CNStr(val)
    return leng > (min - 1)
  } else {
    return true
  }
})
// 最大中文数
extend('maxInZh_CN', (val, max) => {
  return val + ' 长度不能大于' + max + '位(包含中文)'
}, (val, max) => {
  if (val) {
    let leng = zh_CNStr(val)
    return leng < (max + 1)
  } else {
    return true
  }
})
function zh_CNStr (value) {
  var str = value + ''
  var reg = /[\u4e00-\u9fa5]/g
  var zh_CN = str.match(reg) || []

  return str.length + zh_CN.length
}
// 必填验证
extend('required', (val) => {
  return val + '不能为空'
}, (val) => {
  return val !== ''
})
// 验证只能是数字
extend('numeric', (val) => {
  return val + '只能为数字'
}, (val) => {
  var reg = /^[0-9]*$/
  return reg.test(val)
})
// 验证两次输入的是否一致
extend('confirm', (val) => {
  return '请输入一致的' + val
}, (val, confirm) => {
  return val === confirm
})
// 验证手机号
extend('phone', (val) => {
  return '请输入正确的' + val
}, (val) => {
  return val ? /^(13[0-9]|14[5|7]|15[0-9]|17[0-9]|18[0-9])\d{8}$/.test(val) : true
})
// 验证邮箱
extend('email', (val) => {
  return '请输入正确的' + val
}, (val) => {
  return val ? /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(val) : true
})
// 特殊字符校验
extend('noSpecialStr', (val) => {
  return val + '不能包含特殊字符'
}, (val) => {
  var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
  var regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im

  if (regEn.test(val) || regCn.test(val)) {
    return false
  } else {
    return true
  }
})
// 企业抬头不能输入的字符
extend('noSpecialStrToB', (val) => {
  return val + '不能包含特殊字符'
}, (val) => {
  var reg = /[∏¥§℅€℃£℉№℡‰$¢∮※？?<>[\]'&]/im
  if (reg.test(val)) {
    return false
  } else {
    return true
  }
})
// 税号 只能输入数字和字母
extend('taxNo', (val) => {
  return val + '只能输入数字和字母'
}, (val) => {
  val = val + ''
  return val ? /^[0-9A-Za-z]{15,20}$/.test(val) : true
})
// 企业电话 ^[0-9 -]{11,20}$ 可以输入 空格 - 数字 的组合
extend('qiyeTel', (val) => {
  return val + '是7到20位的数字 -组合'
}, (val) => {
  return val ? /^[0-9 -]{7,20}$/.test(val) : true
})
// 银行卡号 ^[ 0-9]{15,18}$ 15个数字+ 3个空格
extend('bankNo', (val) => {
  return val + '格式不正确'
}, (val) => {
  return val ? /^[ 0-9]{16,30}$/.test(val) : true
})
// 密码
extend('password', (val) => {
  return '登录密码必须由至少7个字符，而且同时包含字母和数字'
}, (val) => {
  return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{7,16}$/.test(val)
})

// base
function objAction (obj, key, val) {
  return Object.defineProperty(obj, key, {
    value: val,
    writable: true,
    enumerable: true,
    configurable: true
  })
}

/**
 * 属性描述
 * @param {*} obj
 */
function attr (obj) {
  _name_ = JSON.parse(JSON.stringify(obj))
}

/**
 * 扩展检验方式
 * @param {*} key
 * @param {*} msgCallBack 接收两个值，键-值，值不设定同样校验
 * @param {*} ruleCallBack  返回ture 为通过，默认返回都是false
 */
function extend (key, msgCallBack, ruleCallBack) {
  objAction(typesMsg, key, msgCallBack)
  objAction(types, key, (name, val, ruleVal) => {
    let cb = ruleCallBack(val, ruleVal)
    if (cb) {
      return true
    } else {
      messages.push(typesMsg[`${key}`](name, ruleVal))
    }
  })
}
/**
 * 修改提示信息
 * @param {*} obj
 */
function updateMsg (obj) {
  for (var key in obj) {
    objAction(typesMsg, key, obj[key])
  }
}

/**
 * 验证方式
 * @param {*} data
 * @param {*} rules
 */
function validator (data, rules) {
  messages = []
  // 获取需要验证的键-值
  for (var key in data) {
    // 判断是否在需要检验里面
    if (rules.hasOwnProperty(key)) {
      // 在则保留 值
      let targetVal = data[key]
      // 清空检验
      config = {}
      // 传入的 需要调用的检验
      config = rules[key]
      // console.log('config', config)
      // 获取需要调用的校验的键-值
      for (var rule in config) {
        // 判断是否存在相应定义好的检验方法
        if (types.hasOwnProperty(rule)) {
          let ruleVal = config[rule]
          // 调用对应的校验方法
          let name = _name_[`${key}`] || ''
          // console.log('检验之前', name, targetVal, ruleVal)
          types[`${rule}`](name, targetVal, ruleVal)
        } else {
          // 抛出异常，没有 `${rule}` 检验方法
        }
      }
    } else {
      continue
    }
  }
  return messages
}

let validate = {
  attr: attr,
  extend: extend,
  updateMsg: updateMsg,
  __validate__: function (data, rules) {
    let promise = new Promise((resolve, reject) => {
      let validatorRes = validator(data, rules)
      if (validatorRes.length === 0) {
        resolve(true)
      } else {
        reject(validatorRes)
      }
    })
    return promise
  }
}
export {
  validate
}



// WEBPACK FOOTER //
// ./libs/libs/regular.js